var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Warehouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08l13.8-8.94L38 8l17.2 11.14L69 28.08V65zM22 25h3v14h-3v4h3v18h26V43h3v-4h-3V25h3v-4H22v4zm7 0h18v14H29V25zm0 18h18v14H29V43zm13.32-13.65a2 2 0 01-1.9 2.65h-4.76a2 2 0 11-.08-4h4.76a2 2 0 011.98 1.35zm0 18a2 2 0 01-1.9 2.65h-4.76a2 2 0 11-.08-4h4.76a2 2 0 011.98 1.35z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Warehouse.f79ecdd2.svg";
export { SvgE2Warehouse as ReactComponent };